export default __webpack_public_path__ + "static/media/forum_img_3.0a27d72b.svg";